/**
* @Description 文件功能说明：角色组件
* @Author
* @Time 2021/6/4
**/

/* HTML */
<template>
    <div :class="{'tree-item-box': true, 'mini-box': !showBoxFlag}">

		<div class="box-bar-item" @click="toggleBox" title="展开/收起 车辆分组">
			<i v-if="showBoxFlag" class="iconfont el-icon-my_left2-copy"></i>
			<i v-else class="iconfont el-icon-my_right2"></i>
		</div>

        <div class="tree-group-title">
            <span class="tree-group-name">车辆分组</span>
            <el-button class="tree-group-btn" icon="el-icon-circle-plus-outline" size="mini" @click="addGroup" >新增组</el-button>
        </div>

        <div class="tree-group-item">
            <el-tree
                :props="defaultProps"
                :data="carGroups"
                node-key="id"
                :default-expand-all="true"
                :expand-on-click-node="false"
                @node-click="handleTreeNode"
            >
                <span class="custom-tree-node"
                      slot-scope="{node, data}"
                      @mouseenter="mouseenter(data)"
                      @mouseleave="mouseleave(data)"
                >
                    <span>{{data.label}}</span>
                    <span class="tree-item-button">
                        <el-button
                            type="text"
                            size="mini"
                            title="编辑"
                            v-show="data.show"
                            icon="el-icon-edit"
                            @click="() => {editGroup(data)}"
                        >
                        </el-button>
                        <el-button
                            type="text"
                            size="mini"
                            title="删除"
                            v-show="data.show"
                            icon="el-icon-delete"
                            @click="() => {remove(data)}"
                        >
                        </el-button>
                        <el-button
                            type="text"
                            size="mini"
                            title="新增车辆"
                            v-show="data.show"
                            icon="el-icon-circle-plus"
                            @click="() => {addCar(data)}"
                        >新增车辆
                        </el-button>
                    </span>
                </span>
            </el-tree>
        </div>

        <!--添加或编辑角色弹窗-->
        <CarGroupDialog ref="carGroupDialog" @flushGroup="flushGroup"/>
        <!-- 添加车辆 -->
        <CarDialog ref="carDialog" :carGroups="carGroups" @setTotal="setTotal" />
    </div>

</template>

/* JS */
<script>
    import CarGroupDialog from './CarGroupDialog'
    import ApiCar from '@/request/api-car'
    import CarDialog from './CarDialog'

    export default {

        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 2021/6/4
         */
        props: {
            // 用户组集合
            carGroups: Array,
            /**
             * @Des 展示box
             * @Auth
             * @Date 2021/6/5
             */
			showBoxFlag: {
				type: Boolean,
				default: function (){
					return true
				}
			},
        },

        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/6/4
         */
        components: {
            // 用户组弹窗
            CarGroupDialog,
            CarDialog
        },

        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/6/4
         */
        data() {
            return {

                /**
                 * @Des 树属性默认定义
                 * @Auth
                 * @Date 2021/6/4
                 */
                defaultProps: {
                    label: 'name',
                    children: 'children'
                },
                // 删除锁
                locked: false,
            }
        },

        /**
         * @Des 方法定义
         * @Auth
         * @Date 2021/6/4
         */
        methods: {
			/**
             * @Des mini max box
             * @Auth
             * @Date 2021/6/5
             */
			toggleBox() {
				this.$emit('toggleBox', !this.showBoxFlag);
			},

            /**
             * @Des 添加组
             * @Auth
             * @Date 2021/6/4
             */
            addGroup(data){
                this.$refs.carGroupDialog.openDialog(false, data);
            },

            /**
             * @Des 编辑组
             * @Auth
             * @Date 2021/6/4
             */
            editGroup(data){
                this.$refs.carGroupDialog.openDialog(true, data)
            },

            /**
             * @Des 删除组
             * @Auth
             * @Date 2021/6/4
             */
            remove(data){
                if(this.locked){
                    return;
                }
                this.$confirm('确认要删除【' + data.name + '】组吗？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.locked = true;
                    this.$request.postJsonRequest(ApiCar.deleteCarGroupApi,{
                        groupId: data.id,
                        // projectId: this.$store.state.currentProjectId
                    }).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: '车辆组【' + data.name + '】删除成功！',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            this.flushGroup();
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        this.locked = false;
                    }).catch(error => {
                    	this.locked = false;
                        console.error('车辆组删除异常', ApiCar.deleteCarGroupApi, error);
                    })
                }).catch(() => {
                	this.locked = false;
                    this.$message({
                        type: 'info',
                        message: '已取消删除组【' + data.name + '】'
                    });
                })
            },
            addCar(data){
                this.$refs.carDialog.openDialog('新增车辆', '添加保存', 'add', data);
            },

            /**
             * @Des 处理树节点
             * @Auth
             * @Date 2021/6/4
             */
            handleTreeNode(data){
                this.$emit('setSelectVal', data);
            },
            /**
             * @Des 鼠标进入事件
             * @Auth
             * @Date 2021/6/29
             */
            mouseenter(data){
                this.$set(data, 'show', true);
            },
            /**
             * @Des 鼠标离开事件
             * @Auth
             * @Date 2021/6/29
             */
            mouseleave(data){
                this.$set(data, 'show', false)
            },
            /**
             * @Des 刷新组
             * @Auth
             * @Date 2021/6/29
             */
            flushGroup(groupId, groupName){
                this.$emit("flushGroup", groupId, groupName);
            },
            /**
             * @Des 改变总数
             * @Auth
             * @Date 2021/6/21
             */
            setTotal(val){
                this.$emit("setTotal",val);
            },
        },

        /**
         * @Des 初始化加载
         * @Auth
         * @Date 2021/6/4
         */
        mounted() {
        }

    }
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>




// WEBPACK FOOTER //
// src/components_pages/Car/CarGroupTree.vue